import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import Detail from './Detail';

const UserBasedata = (props) => {
  return (
    <Switch>
      <Route
        render={(routerProps) => {
          return <Detail {...routerProps} {...props} />;
        }}
      />
    </Switch>
  );
};

export default withRouter(UserBasedata);
